import React from 'react';
import { useToast } from '../../context/ToastContext';

const ToastDemo = () => {
  const toast = useToast();

  const showSuccessToast = () => {
    toast.success('Operation completed successfully!', {
      title: 'Success',
      duration: 4000
    });
  };

  const showErrorToast = () => {
    toast.error('Something went wrong. Please try again.', {
      title: 'Error',
      duration: 6000
    });
  };

  const showWarningToast = () => {
    toast.warning('Please review your input before proceeding.', {
      title: 'Warning',
      duration: 5000
    });
  };

  const showInfoToast = () => {
    toast.info('Here is some helpful information for you.', {
      title: 'Information',
      duration: 4000
    });
  };

  const showLoadingToast = () => {
    const loadingId = toast.loading('Processing your request...', {
      title: 'Loading',
      duration: 0 // Don't auto-dismiss
    });

    // Simulate async operation
    setTimeout(() => {
      toast.dismiss(loadingId);
      toast.success('Request completed!');
    }, 3000);
  };

  const showCustomToast = () => {
    toast.custom({
      type: 'info',
      title: 'Custom Toast',
      message: 'This is a custom toast with special styling!',
      duration: 5000
    });
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-white rounded-lg shadow-lg">
      <h2 className="text-xl font-bold mb-4 text-gray-800">Toast Demo</h2>
      <div className="space-y-3">
        <button
          onClick={showSuccessToast}
          className="w-full px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
        >
          Show Success Toast
        </button>
        <button
          onClick={showErrorToast}
          className="w-full px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
        >
          Show Error Toast
        </button>
        <button
          onClick={showWarningToast}
          className="w-full px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition-colors"
        >
          Show Warning Toast
        </button>
        <button
          onClick={showInfoToast}
          className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Show Info Toast
        </button>
        <button
          onClick={showLoadingToast}
          className="w-full px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
        >
          Show Loading Toast
        </button>
        <button
          onClick={showCustomToast}
          className="w-full px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
        >
          Show Custom Toast
        </button>
      </div>
    </div>
  );
};

export default ToastDemo;
